import styled from "styled-components"
import { Grid, mixins } from "@fastly/consistently"
import SupportIcon from "../images/icons/icon-support.inline.svg"
import PlusIcon from "../images/icons/icon-close-circle.inline.svg"

const { paddingBlock } = mixins

/*
The Support plan component takes an array of 4-5 text objects.
The component assumes that internationalization has happened prior to passing to this component
The item at index 0 should be the section title (h3) and optional subtitle.
The items at index 1-3 represent the three plan types
If an optional index 4 is present than styling changes to accomodate it
*/

const iconColors = ["var(--red-light)", "var(--orange-light)", "var(--blue-light)"]

const StyledTitle = styled.div`
  color: var(--white);
  grid-column: 1/-1;
  text-align: center;

  & h3 {
    color: currentColor;
  }

  & a {
    color: var(--blue-light);
  }

  & p {
    max-width: 375px;
    margin: 0 auto;
    color: var(--grey-40);
  }

  & p:empty {
    display: none;
  }
`

const StyledColumn = styled.div`
  background-color: var(--color-black);
  color: var(--grey-30);
  text-align: center;
  padding: ${(props) => (props.tlsAddOn ? `2.2rem 1.6rem 1.6rem` : `2.2rem 1.6rem`)};
  border-radius: ${(props) => (props.tlsAddOn ? `16px 16px 0 0` : `16px`)};
  height: ${(props) => (props.tlsAddOn ? `auto` : `fit-content`)};

  & h5 {
    color: var(--white);
    ${paddingBlock("1.1rem")}
  }

  & svg {
    height: 50px;
    width: 50px;
    fill: ${(props) => iconColors[props.index - 1]};
  }

  & p {
    margin: 0;
  }

  & a {
    color: var(--blue-light);
  }

  @media (min-width: 768px) and (max-width: 992px) {
    width: 594px;
    justify-self: center;
  }
`

const StyledAddon = styled(StyledColumn)`
  border-radius: 0 0 16px 16px;
  border-top: 1px solid var(--black);
  padding: 1.6rem;
  position: relative;
  /* equal (plus a couple px) to gap */
  transform: translateY(-32px);

  & svg {
    position: absolute;
    top: 0;
    left: 50%;
    /* rotate close icon */
    transform: translate(-50%, -50%) rotate(45deg);
    width: 15px;
    height: 15px;
    background: var(--grey-90);
    border-radius: 50%;
  }

  & svg path {
    fill: ${iconColors[2]};
  }

  & h5 {
    font: var(--h6);
    padding: 0;
  }

  & a {
    display: block;
  }

  @media (min-width: 992px) {
    grid-column: 3/4;
  }
`

const SupportPlans = ({ content }) => {
  const supportPlanContent = content.map((text, i) => {
    if (i > 0 && i < 4)
      return (
        <StyledColumn index={i} tlsAddOn={i === 3 && content.length === 5}>
          <SupportIcon />
          {text}
        </StyledColumn>
      )
    if (i === 4)
      return (
        <StyledAddon>
          <PlusIcon />
          {text}
        </StyledAddon>
      )
    return <StyledTitle key={text.key}>{text}</StyledTitle>
  })

  return (
    <Grid sm={1} lg={3}>
      {supportPlanContent}
    </Grid>
  )
}

export default SupportPlans
